import { ChangeDetectionStrategy, Component, output, input } from '@angular/core';

import { BillingPlanTier } from '@core/billing-types';
import { PlanButtonComponent } from '@core/user-interface-legacy';

@Component({
  imports: [PlanButtonComponent],
  selector: 'rt-feature-button',
  template: `<rt-plan-button
    [hasIcon]="true"
    [variant]="buttonVariant"
    (click)="openPlanPicker.emit()"
    class="default"
    ><ng-content
  /></rt-plan-button>`,
  styleUrls: ['./feature-button.component.less'],
  host: {
    '[class]': '"plan-"+ plan()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureButtonComponent {
  public readonly plan = input<BillingPlanTier | null>(undefined!);
  public readonly availableInNewPlans = input<boolean>(false);

  public openPlanPicker = output<void>();

  public BillingPlanTier: typeof BillingPlanTier = BillingPlanTier;

  public get buttonVariant() {
    if (this.availableInNewPlans()) return BillingPlanTier.Optimize;
    const plan = this.plan();
    switch (plan) {
      case BillingPlanTier.Lead:
      case BillingPlanTier.Scale:
      case BillingPlanTier.Grow:
      case BillingPlanTier.Optimize:
        return plan;
      default:
        return BillingPlanTier.Scale;
    }
  }
}
